import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { GAME_BY_ID, type GameId } from '../games';
import { gameContent } from '../../content';
import GameSeoContent from '../../content/GameSeoContent';
import { useMeta } from '../useMeta';
import { gamePath } from '../site';
import './gameShell.css';

interface Props {
  gameId: GameId;
  level?: number;
  children: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export default function GameShell({ gameId, level, children, subtitle, actions }: Props) {
  const game = GAME_BY_ID[gameId];
  const content = gameContent(gameId);
  const levelLabel = level ? game.progressLabel(level) : '';

  useMeta({
    title: content?.metaTitle ?? `${game.title} — ${game.tagline}`,
    description: content?.metaDescription ?? game.tagline,
    path: gamePath(gameId),
  });
  return (
    <div
      className="game-shell"
      style={{ ['--game-accent' as string]: game.accentVar }}
    >
      <header className="game-header">
        <div className="container game-header-row">
          <Link to="/" className="game-back" aria-label="Back to hub">
            ← <span className="game-back-label">Games</span>
          </Link>
          <div className="game-title-block">
            <div className="game-title">{game.title}</div>
            <div className="game-subtitle">{subtitle ?? levelLabel ?? game.tagline}</div>
          </div>
          <div className="game-actions">{actions}</div>
        </div>
      </header>
      <main className="container game-body">{children}</main>
      {/* The evergreen half of the page: what this game is and how to play it.
          Prerendered into the HTML at build time from the same component, so it
          is readable without JavaScript. */}
      {content && <GameSeoContent content={content} />}
    </div>
  );
}
